"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports["default"] = void 0;

var _react = _interopRequireDefault(require("react")),
    _uiKit = require("@devsta/ui-kit"),
    _AssetPreview = _interopRequireDefault(require("../../../../AssetPreview")),
    CommentAsset = function CommentAsset(_ref) {
  var asset = _ref.asset,
      deleteAsset = _ref.deleteAsset;
  return _react["default"].createElement("div", {
    className: "comment-asset"
  }, _react["default"].createElement(_AssetPreview["default"], {
    asset: asset,
    width: "50px",
    height: "50px",
    borderRadius: 0,
    hideFileTypeIcon: !0
  }), _react["default"].createElement("p", {
    className: "comment-asset__title"
  }, asset.filename), _react["default"].createElement(_uiKit.Icon, {
    className: "comment-asset__trash-icon",
    onClick: deleteAsset,
    name: "trash",
    color: "russian",
    hoverColor: "black",
    size: 15
  }));
},
    _default = CommentAsset;

exports["default"] = _default;